import { useEffect, DependencyList } from 'react';

export function useDebounceEffect(fn: (deps?: DependencyList) => void, waitTime: number, deps?: DependencyList) {
  useEffect(() => {
    const timer = setTimeout(() => {
      // @ts-ignore
      fn(...deps);
    }, waitTime);

    return () => clearTimeout(timer);
  }, deps);
}
